import React from 'react';

const ErrorMessage = ({ errorMsg = '' }) => {
  return !!errorMsg && <div style={{ color: 'var(--ant-color-error)', fontSize: 13 }}>{errorMsg}</div>;
};

export default ErrorMessage;
